import { createSelector } from 'reselect';

export const selectFetchingEntities = state => state.data.fetchingEntities;
export const selectEntities = state => state.data.entities;
export const selectGroupingLevels = state => state.data.groupingLevels;
export const selectFetchingGroupingLevels = (state) => state.data.groupingLevelsFetching;
export const selectBucketLevels = (state) => { console.log("state.data.bucketLevels", state); return state.data.bucketLevels };
export const selectFetchingBucketLevels = (state) => state.data.bucketLevelsFetching;
export const selectGroupingLevelOptions = createSelector(
  selectGroupingLevels,
  (groupingLevels) => groupingLevels
    .map(({ id, display }) => ({ label: display, value: id }))
    .sort((e1, e2) => {
      if (e1.label < e2.label) return -1;
      if (e1.label > e2.label) return 1;
      return 0;
    }),
);
export const selectGetGroupingLevelOption = createSelector(
  selectGroupingLevelOptions,
  (groupingLevels) => {
    const groupingLevelsByLevelValue = groupingLevels.reduce((map, levelOption) => {
      map[levelOption.value] = levelOption;
      return map;
    }, {});

    return (levelValue) => groupingLevelsByLevelValue[levelValue];
  },
);
